import popolazioneSalute from '../assests/ico-popolazione-e-salute.png';
import areeIntervento from '../assests/ico-aree-di-intervento.png';
import gestioneRisorse from '../assests/ico-gestione-risorse.png';
import attuazioneObiettiviPSSR from '../assests/ico-attuazione-servizi-pssr.png';

const CARDS_LIST_TO_VIEW = [
    {
        id: 'popolazioneSalute',
        src: popolazioneSalute,
        href: '',
        tipologia: '01',
        title: 'Popolazione e salute',
        alt: 'Menu Popolazione e salute',
        isDisabled: false

    },
    {
        id: 'areeIntervento',
        src: areeIntervento,
        href: '',
        tipologia: '02',
        title: 'Aree di intervento',
        alt: 'Menu Aree di intervento',
        isDisabled: false
    },
    {
        id: 'gestioneRisorse',
        src: gestioneRisorse,
        href: '',
        tipologia: '03',
        title: 'Gestione risorse',
        alt: 'Menu Gestione risorse',
        isDisabled: false
    },
    {
        id: 'attuazioneObiettiviPSSR',
        src: attuazioneObiettiviPSSR,
        href: '',
        tipologia: '05',
        title: 'Attuazione obiettivi PSSR',
        alt: 'Menu Attuazione obiettivi PSSR',
        isDisabled: false
    }
];

const removeTags = (str) => {
    let newString = ""
    if (!str)
        return "";
    else
        newString = str.toString();

    return newString.replace( /(<([^>]+)>)/ig, '').replace(/&nbsp;/g, '').trim();
}


const ID_ATTUAZIONE_OBIETTIVI_PSSR = "attuazioneObiettiviPSSR";
const APP_NAME = "Portale RSSR"

export default CARDS_LIST_TO_VIEW;
export { ID_ATTUAZIONE_OBIETTIVI_PSSR, APP_NAME, removeTags };